export const noop = () => {}
export type OnSuccess = () => void;
export type OnFailure = (error: any) => void;
export type OnSuccessData<T> = (data: T) => void;
export type OnFailureData<T> = (data: T) => void;